import BaseModel from './BaseModel'

export default class ContactModel extends BaseModel {
  constructor(data: any, relation: any) {
    const fields = {
      ID_PROSPECT: null,
      NOM: '',
      PRENOM: '',
      CODE_REF_CIVILITE: null,
      TELEPHONE1: '',
      TELEPHONE2: '',
      EMAIL: '',
      CONTACT_PRINCIPAL: 0,
      CODE_REF_ROLE: null,
      NIVEAU_MOTIVATION: null,
      POSTIONNEMENT_DECISIONNAIRE: 0,
      POSTIONNEMENT_ANALYSTE: 0,
      POSTIONNEMENT_COMPTABLE: 0,
      POSTIONNEMENT_TRAVAUX: 0,
      POSTIONNEMENT_INFORMATIQUE: 0,
      POSTIONNEMENT_COMMUNICATION: 0,
      COMMENTAIRES: ''
    }
    super(data, relation, fields)
  }
}
